module.exports = __webpack_public_path__ + "static/img/2.5e2e73e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/2.png
// module id = WjQi
// module chunks = 2